virtual task body();
{{#if isPipelinedRead}}
  for ({{ beatIndexVariable.identifier }} = 0; {{ beatIndexVariable.identifier }} < {{ responseItemHandle.identifier }}.{{ responseItemHandle.klass.lenVariable.identifier }}; {{ beatIndexVariable.identifier }}++) begin
    {{> (partial "snippets/start-item") context=. reqHandle=superclass.reqHandle}}
  end
{{else}}
  {{> (partial "snippets/start-item") context=. reqHandle=superclass.reqHandle}}
{{/if}}
endtask
